export default "__VITE_ASSET__1e760787__"